"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBoxTabsOrder = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const InfoBoxTabItem_1 = require("../InfoBoxTabItem");
const infobox_1 = require("../../utils/infobox");
const PreferencesServiceProvider_1 = require("../../providers/PreferencesServiceProvider");
const i18n_1 = require("@completeanatomy/i18n");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const ui_1 = require("@completeanatomy/ui");
const useInfoBoxTabsOrder_1 = require("../../hooks/useInfoBoxTabsOrder");
const TABS_DICT = i18n_1.Strings.infoBox.tabs;
function InfoBoxTabsOrderBase({ className }, ref) {
    const preferences = (0, PreferencesServiceProvider_1.usePreferencesService)();
    const dndManager = (0, ui_1.useDragDropManager)();
    const infoBoxTabOrder = (0, useInfoBoxTabsOrder_1.useInfoBoxTabsOrder)();
    const updateOrder = (0, react_1.useCallback)((newOrder) => {
        preferences.setToolsOrder(newOrder);
    }, [preferences]);
    const [items, setItems] = (0, react_1.useState)(infoBoxTabOrder
        .filter(type => type !== bridge_schema_1.InfoBoxTabType.MultiSelect)
        .map(type => (Object.assign(Object.assign({}, infobox_1.INFOBOX_TABS[type]), { type }))));
    const changeItems = (0, react_1.useCallback)((dragIndex, hoverIndex) => {
        const item = items[dragIndex];
        items.splice(dragIndex, 1);
        items.splice(hoverIndex, 0, item);
        setItems([...items]);
    }, [items]);
    const commitOrder = () => {
        updateOrder(items.map(i => i.type));
    };
    const renderItem = ({ type, icon = ui_1.Icons.Info, key, canDrag }, i) => {
        return ((0, jsx_runtime_1.jsx)(DragSourceItem, { selected: canDrag, type: type, icon: icon, label: key ? (0, i18n_1.Localized)(TABS_DICT[key]) : bridge_schema_1.InfoBoxTabType[type], index: i, changeItems: changeItems, dndManager: dndManager, commitOrder: commitOrder, "data-e2e": 'InfoBoxTabsOrderBase_DragSourceItem' }, key));
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, ref: ref, "data-e2e": 'InfoBoxTabsOrderBase_Container', children: [(0, jsx_runtime_1.jsx)(DragPreview, { dndManager: dndManager, "data-e2e": 'InfoBoxTabsOrderBase_DragPreview' }), items.map(renderItem)] }));
}
exports.InfoBoxTabsOrder = (0, react_1.forwardRef)(InfoBoxTabsOrderBase);
const Container = styled_components_1.default.div `
  display: flex;
  flex-flow: row wrap;
`;
const DnDType = 'DisplayOrderItem';
const DropTargetItem = (0, ui_1.withDropTarget)(({ forwardedRef, index, changeItems, dndManager, commitOrder }) => ({
    accept: DnDType,
    hover(item, monitor) {
        const ref = forwardedRef;
        if (!ref.current) {
            return;
        }
        const dndBackend = dndManager.getBackend();
        const { isKeyboardBackend } = dndBackend.profile();
        const dragIndex = item.index;
        const hoverIndex = index;
        if (dragIndex === hoverIndex) {
            return;
        }
        // for mouse and touches
        if (!isKeyboardBackend) {
            const { x: dragX } = monitor.getClientOffset();
            const hoveredNode = ref.current;
            const hoverBoundingRect = hoveredNode.getBoundingClientRect();
            const hoverLeft = hoverBoundingRect.left;
            const hoverRight = hoverBoundingRect.right;
            if (!(dragX >= hoverLeft && dragX <= hoverRight)) {
                return;
            }
        }
        item.index = hoverIndex;
        changeItems(dragIndex, hoverIndex);
    },
    drop() {
        commitOrder();
        return undefined;
    },
}))(InfoBoxTabItem_1.InfoBoxTabItem);
const DragSourceItem = (0, ui_1.withDragSource)(({ index, type }) => ({
    type: DnDType,
    item: { index, type },
    collect: monitor => {
        const item = monitor.getItem() || {};
        return {
            stub: index === item.index,
        };
    },
}))(DropTargetItem);
function DragPreview({ dndManager }) {
    return ((0, jsx_runtime_1.jsx)(ui_1.DnDPreview, { "data-e2e": 'DragPreview_DnDPreview', children: ({ item: { index, type }, style }) => {
            const dndBackend = dndManager.getBackend();
            const { isKeyboardBackend } = dndBackend.profile();
            // react-dnd-accessible-backend creates its own preview
            if (isKeyboardBackend) {
                // @ts-ignore - types are not correct for the Preview interface
                return null;
            }
            const item = infobox_1.INFOBOX_TABS[type];
            return ((0, jsx_runtime_1.jsx)(InfoBoxTabItem_1.InfoBoxTabItem, { icon: item.icon || ui_1.Icons.Info, label: item.key ? (0, i18n_1.Localized)(TABS_DICT[item.key]) : bridge_schema_1.InfoBoxTabType[type], index: index, style: style, selected: true, "data-e2e": 'DragPreview_InfoBoxTabItem' }));
        } }));
}
